import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

const features = [
  'Feature at the top of search results for the same industry and location.',
  'Feature on the SEEK Business homepage.',
  'Benefit from double the amount of ad views (compared to similar listings in the organic search results).',
  'Your ad remains boosted for the life of your ad.',
];

interface SearchBoostProductDetailsProps {
  boostCost: number;
}

const SearchBoostProductDetails = ({
  boostCost,
}: SearchBoostProductDetailsProps) => (
  <Card data={{ testid: 'search-boost-product-details' }}>
    <Stack space="large" align="left">
      <Heading level="3">Purchase a Search Boost Add-On</Heading>

      <Stack space="medium">
        <Heading level="4">
          Reach more buyers with better ad visibility:
        </Heading>
        <List
          type="icon"
          icon={<IconTick tone="positive" />}
          size="large"
          space="large"
        >
          {features.map((feature, key) => (
            <Text key={key}>{feature}</Text>
          ))}
        </List>
      </Stack>

      <Text
        size="large"
        data={{ testid: 'search-boost-product-details-price' }}
      >
        ${boostCost / 100} + GST
      </Text>
    </Stack>
  </Card>
);

export default SearchBoostProductDetails;
